import { useDispatch } from "react-redux";
import { filteredSaved } from "../../features/filter/filterSlice";

export default function Filter() {
  const dispatch = useDispatch();

  const handleSaved = (isSaved) => {
    dispatch(filteredSaved(isSaved));
  };

  return (
    <div className="sidebar-content">
      <h4>Filter</h4>
      <div className="radio-group">
        {/* handle filter on button click */}
        <div>
          <input
            type="radio"
            name="filter"
            id="lws-all"
            className="radio"
            defaultChecked
            onChange={() => handleSaved(false)}
          />
          <label htmlFor="lws-all">All</label>
        </div>
        <div>
          <input
            type="radio"
            name="filter"
            id="lws-saved"
            className="radio"
            onChange={() => handleSaved(true)}
          />
          <label htmlFor="lws-saved">Saved</label>
        </div>
      </div>
    </div>
  );
}
